const SkeletonBlogDetail = () => {
    return (
      <div className="animate-pulse">
        {/* Skeleton for Blog Image */}
        <div className="bg-teal-100 h-96 w-full mb-5"></div>
  
        {/* Skeleton for Blog Title */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-teal-100 h-8 w-3/4 mb-4"></div>
  
          {/* Skeleton for Blog Author */}
          <div className="bg-teal-100 h-5 w-1/4 mb-5"></div>
  
          {/* Skeleton for Blog Content */}
          <div className="space-y-4">
            <div className="bg-teal-100 h-4 w-full"></div>
            <div className="bg-teal-100 h-4 w-full"></div>
            <div className="bg-teal-100 h-4 w-3/4"></div>
            <div className="bg-teal-100 h-4 w-4/5"></div>
          </div>
  
          {/* Skeleton for Sections */}
          <div className="mt-10 space-y-8">
            {[...Array(2)].map((_, index) => (
              <div key={index}>
                <div className="bg-teal-100 h-6 w-1/2 mb-4"></div>
                <div className="bg-teal-100 h-48 w-full mb-4"></div>
                <div className="bg-teal-100 h-4 w-full mb-2"></div>
                <div className="bg-teal-100 h-4 w-3/4"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };
  export default SkeletonBlogDetail;